import * as Yup from 'yup';

export const salesOrderDetailValidationSchema = Yup.object().shape({
    positions: Yup.array().of(
        Yup.object().shape({
            deliveryAddress: Yup.mixed().required('app.error.required'),
            customerContact: Yup.mixed().required('app.error.required'),
            items: Yup.array()
                .of(
                    Yup.object().shape({
                        name: Yup.object().required('app.error.required'),
                        quantity: Yup.number()
                            .required('app.error.required')
                            .moreThan(0, 'app.error.required')
                            .typeError('app.error.required'),
                    })
                )
                .required('app.error.required')
                .min(1, 'app.error.required'),
        })
    ),
});
